import { render, staticRenderFns } from "./Brandkit.vue?vue&type=template&id=5f4ab181&scoped=true&"
import script from "./Brandkit.vue?vue&type=script&lang=js&"
export * from "./Brandkit.vue?vue&type=script&lang=js&"
import style0 from "./Brandkit.vue?vue&type=style&index=0&id=5f4ab181&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4ab181",
  null
  
)

export default component.exports